import React from 'react'

export function ChecklistIcon({ size = 16, ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...rest}
    >
      <path d="M3 4.5l1.5 1.5L7 3.5" />
      <path d="M3 9.5l1.5 1.5L7 8.5" />
      <path d="M9 4h4.5" />
      <path d="M9 9h4.5" />
      <path d="M3 14h10.5" />
    </svg>
  )
}
